import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg1Car = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 50,
	viewBox: "195 85 250 270",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("style", { children: "\n    .greyColor {\n      fill: #eee !important;\n    }\n  " }),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.463 245.211C206.547 248.029 216.748 247.795 221.713 247.325C221.713 225.055 238.414 219.958 246.764 220.193C266.806 223.294 270.462 239.573 269.785 247.325H374.053C374.053 238.281 378.86 220.193 398.089 220.193C417.318 220.193 422.351 238.281 422.463 247.325C440.609 250.426 442.888 238.751 441.76 232.525C437.156 212.793 420.884 208.565 413.323 208.917C408.448 208.071 390.528 202.927 382.178 200.46C330.45 152.539 253.648 175.795 221.713 193.413H208.172C203.026 193.413 201.288 198.111 201.062 200.46V213.498L197 220.193V234.287C197 238.516 202.642 243.331 205.463 245.211Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.733 202.575H297.206L293.482 180.376C278.248 177.909 253.874 190.242 244.733 195.175C237.421 199.121 241.687 201.752 244.733 202.575Z",
			stroke: "#5f5f5f",
			strokeWidth: 5,
			className: "greyColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M304.654 202.575L301.268 180.376C335.46 177.557 351.71 190.947 360.173 195.175C366.944 198.558 364.349 201.517 362.204 202.575H304.654Z",
			stroke: "#5f5f5f",
			strokeWidth: 5,
			className: "greyColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.545 245.563C262.545 255.565 254.78 263.5 245.41 263.5C236.04 263.5 228.275 255.565 228.275 245.563C228.275 235.561 236.04 227.626 245.41 227.626C254.78 227.626 262.545 235.561 262.545 245.563Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M414.885 245.563C414.885 255.565 407.12 263.5 397.75 263.5C388.38 263.5 380.615 255.565 380.615 245.563C380.615 235.561 388.38 227.626 397.75 227.626C407.12 227.626 414.885 235.561 414.885 245.563Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		})
	]
});
const ForwardRef = forwardRef(Svg1Car);
export default ForwardRef;
